import { render, staticRenderFns } from "./billingOfLadingRecord.vue?vue&type=template&id=bacc48f6&"
import script from "./billingOfLadingRecord.vue?vue&type=script&lang=js&"
export * from "./billingOfLadingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bacc48f6')) {
      api.createRecord('bacc48f6', component.options)
    } else {
      api.reload('bacc48f6', component.options)
    }
    module.hot.accept("./billingOfLadingRecord.vue?vue&type=template&id=bacc48f6&", function () {
      api.rerender('bacc48f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/mbl2/billingOfLadingRecord.vue"
export default component.exports